import colors from "tailwindcss/colors"

export default defineAppConfig({
  ui: {
    colors: {
      primary: 'qb-green',
      secondary: 'qb-purple',
      accent: 'qb-yellow'
    },
    button: {
      slots: {
        label: 'text-black',
        leadingIcon: 'text-black',
        trailingIcon: 'text-black'
      }
    },
    card: {
      slots: {
        root: 'rounded-lg shadow-md'
      }
    }
  }
})